"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clear = exports.toggleModal = exports.detachFoldersFailure = exports.detachFoldersSuccess = exports.detachFoldersRequest = void 0;
const ActionTypes = require("../../actionTypes/vektorio/detachFolders");
const detachFoldersRequest = (payload) => ({
    type: ActionTypes.DETACH_REQUEST,
    payload
});
exports.detachFoldersRequest = detachFoldersRequest;
const detachFoldersSuccess = () => ({
    type: ActionTypes.DETACH_SUCCESS
});
exports.detachFoldersSuccess = detachFoldersSuccess;
const detachFoldersFailure = (payload) => ({
    type: ActionTypes.DETACH_FAILURE,
    payload
});
exports.detachFoldersFailure = detachFoldersFailure;
const toggleModal = () => ({
    type: ActionTypes.TOGGLE_MODAL
});
exports.toggleModal = toggleModal;
const clear = () => ({
    type: ActionTypes.CLEAR
});
exports.clear = clear;
//# sourceMappingURL=detachFolders.js.map